export default {
  getAutocompleteContacts: (state) => state.autocompleteContacts,
}